'use client';
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { ErrorFallback } from '@/shared/ui/error-boundary/error-fallback';

// Render-error boundary for the [locale] route segment. Reports to Sentry and shows
// a localized fallback with a "try again" action instead of a blank page.
export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return <ErrorFallback onReset={reset} />;
}
